if (!customElements.get('nordfresk-image-compare')) {
  customElements.define('nordfresk-image-compare', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const input = this.querySelector('input');
      input.addEventListener('input', () => this.style.setProperty('--position', input.value + '%'));
    }
  });
}
if (!customElements.get('nordfresk-offer-price')) {
  customElements.define('nordfresk-offer-price', class extends HTMLElement {
    connectedCallback() {
      const source = document.querySelector('#product-section product-price');
      if (!source) return;
      const update = () => {
        const price = source.querySelector('.price');
        const compare = source.querySelector('.compare-at-price');
        if (price) this.querySelector('strong').textContent = price.textContent;
        this.querySelector('s').hidden = !compare;
        this.querySelector('s').textContent = compare?.textContent || '';
      };
      this.observer = new MutationObserver(update);
      this.observer.observe(source, { childList: true, subtree: true, characterData: true });
      update();
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}
// Start silent demonstrations as they enter view; retry after media loads or a user gesture.
(() => {
  const setup = (root = document) => {
    root.querySelectorAll('.ncc video').forEach(video => {
      if (video.dataset.autoplayReady) return;
      video.dataset.autoplayReady = 'true';
      video.muted = true;
      video.defaultMuted = true;
      video.loop = true;
      video.playsInline = true;
      const play = () => {
        if (video.dataset.inView !== 'true' || document.hidden) return;
        video.play().catch(() => {});
      };
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          video.dataset.inView = String(entry.isIntersecting);
          if (entry.isIntersecting) play(); else video.pause();
        });
      }, { threshold: 0.1 });
      observer.observe(video);
      video.addEventListener('loadeddata', play);
      document.addEventListener('visibilitychange', play);
      document.addEventListener('pointerdown', play, { once: true, passive: true });
    });
  };
  setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();
